import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const logout = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.AUTH.LOGOUT,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}